<template>
  <div class="mod-web-activity-detail">
    <common-error :is-error="pageError"
                  :title="$t('content.commonErrorTitle')"
                  :desc="$t('content.commonErrorDesc')">
      <template v-if="!loading">
        <p class="mod-web-activity-detail__back-btn-mb" @click="goBack">
          {{ $t('content.webDetailAllEvents') }}
        </p>
        <img class="mod-web-activity-detail__banner mod-web-activity-detail__head-banner" v-lazy="detail.banner" />
        <div class="mod-web-activity-detail__main">
          <section class="mod-web-activity-detail__left-container">
            <p class="mod-web-activity-detail__back-btn" @click="goBack">
              {{ $t('content.webDetailAllEvents') }}
            </p>
            <section class="mod-web-activity-detail__main-info">
              <h1 class="mod-web-activity-detail__title">
                {{ detail.title }}
              </h1>
              <section class="mod-web-activity-detail__right-info">
                <right-info :detail="detail" @change-scene="handleChangeScene"></right-info>
              </section>
              <content-render :class="bem('content-section')"
                              :content="detail.content"
                              :use-native="true"
                              @link-click="handleLinkJump"></content-render>
              <img class="mod-web-activity-detail__banner mod-web-activity-detail__banner-wrap" v-lazy="detail.banner" />
              <section :class="bem('main-detail')" v-if="detail.tips">
                <p :class="bem('title-detail')">
                  {{ $t('content.activityTitleAttention') }}
                </p>
                <content-render :class="bem('attention-section')"
                                :content="detail.tips"></content-render>
              </section>
            </section>
          </section>
          <section class="mod-web-activity-detail__right-container">
            <right-info :detail="detail" @change-scene="handleChangeScene"></right-info>
          </section>
        </div>
        <web-operation-footer :text="registrationText"
                              :disabled="registrationDisabled"
                              @btn-click="handleRegistration"
                              :content="footerContent"
                              :left-content="footerLeftContent"></web-operation-footer>
      </template>
      <template v-if="loading">
        <skeleton class="mod-web-activity-detail__skeleton" :config="activitySkeleton"></skeleton>
        <skeleton class="mod-web-activity-detail__skeleton-mb" :config="activityMbSkeleton"></skeleton>
      </template>
    </common-error>
  </div>
</template>

<script>
// import {mapState, mapMutations} from 'vuex';

import ContentRender from '@/components/common/ContentRender/Index';
import CommonError from '@/components/common/CommonError';

import Skeleton from '@/components/ui/Skeleton';

import WebOperationFooter from '@/components/web_activity/WebOperationFooter';
import {
  baseMixin, supreme, scrollBehaviorMixin
} from '@/supreme-core';
import util from '@/util/util';
import {
  jump, goto, getWebUrl
} from '@/util/common/jump';
import {formatActivityData} from '@/util/common/format';
import {bffClient} from '~/client'
import {CACHE_KEYS, REG_STATUS} from '@/assets/js/constant';
import {activitySkeleton, activityMbSkeleton} from '@/assets/js/skeletons';

import nav from '@/assets/images/icon/icon_navigation_28.png';
import RightInfo from './RightInfo';

export default {
  name: 'Index',
  mixins: [baseMixin, scrollBehaviorMixin],
  components: {
    ContentRender,
    Skeleton,
    WebOperationFooter,
    CommonError,
    RightInfo
  },
  data(){
    return {
      detail: {
        banner: '',
        content: {},
        tips: null,
        publisher: {
          medal: {}
        },
        place: {},
        scenes: [],
        pageImages: []
      },
      footerLeftContent: {},
      loading: true,
      pageError: false,
      activitySkeleton,
      activityMbSkeleton,
      icons: {
        nav
      }
    };
  },
  mounted(){
    // 进页面先清除上一次缓存
    this.clearCache();
    // this.mtaPageView();
    if (this.$route.query.id){
      this.initData();
    }
  },
  computed: {
    isInWebview(){
      return false;
    },
    calcScenes(){
      return (this.detail.scenes || []).filter(item => item.available);
    },
    limitDesc(){
      let limit = this.detail.limit
      return (
        limit > 1 ? this.$t('content.activityLimitsDesc') :
        this.$t('content.activityLimitDesc')
      ).replace('${limit}', limit);
    },
    costDesc(){
      let cost = this.detail.cost
      return cost ?
        this.$t('content.activityCostDesc').replace('${cost}', cost) :
        this.$t('content.activityFreeDesc')
    },
    footerContent(){
      return {
        desc: this.costDesc,
        subDesc: this.limitDesc
      };
    },
    // 报名按钮状态
    registrationDisabled(){
      // 按钮状态
      // 已报名按钮可点击
      if (this.detail.registered){
        return false;
      }
      // 可报名或无状态时，按钮可点击
      if (this.detail.status === 'registrable' || !this.detail.status){
        return false;
      }
      return true;
    },
    // 报名按钮文案
    registrationText(){
      const status = REG_STATUS[this.detail.status];
      const map = {
        1: 'content.activityAttendBtn',
        2: 'content.activityFullBtn',
        3: 'content.activityBeforeBtn',
        4: 'content.activityAfterBtn',
        5: 'content.activityStartedBtn',
        6: 'content.activityExpiredBtn'
      };

      const text = this.detail.registered ? 'content.activityBookedBtn' : map[status];

      return this.$t(text);
    },
    shareOptions(){
      return [{
        label: this.$t('content.commonShareText'),
        value: 'share'
      }];
    }
  },
  methods: {
    goBack(){
      location.href = `${location.origin}/${this.$route.params.languages}/nio-event`;
    },
    initData(needLoading = false, hasInit = false){
      bffClient.getActivityDetail(this.$route.query.id).then(data => {
        this.detail = formatActivityData(data);
        if (!hasInit){
          this.loading = false;
          this.pageError = false;
          supreme.localCache.add(CACHE_KEYS.DETAIL, this.detail);
        } else {
          supreme.localCache.set(CACHE_KEYS.DETAIL, this.detail);
        }
      }).catch(err => {
        if (!hasInit){
          this.pageError = true;
        }
      })
    },
    handleRegistration(){
      const {params, query} = this.$route
      if (this.detail.registered) {
        location.href = `${location.origin}/${params.languages}/agenda/${this.detail.registrationId}`;
      } else {
        this.goto('registration', {id: query.id});
        // this.$router.push({name: 'registration', query: {id: query.id}}).catch();
      }
    },
    clearCache(){
      // 页面销毁时清除相关的缓存
      Object.keys(CACHE_KEYS).forEach(key => {
        supreme.localCache.delete(CACHE_KEYS[key]);
      });
    },
    handleLinkJump(link){
      goto(link, {useNative: this.isInWebview});
    },
    formatDate(date){
      if (!date){
        return '';
      }
      const {dateRange, weekday, dayDiff} = date;

      return `${dayDiff > 0 ? `${dayDiff} ${this.$t('content.activitySceneFormatDay')}` : weekday}, ${dateRange}`;
    },
    handleChangeScene(item){
      const {formatDate, formatTime, formatDesc} = item;

      this.footerLeftContent = {
        desc: this.formatDate(formatDate),
        subDesc: `${formatTime} ${formatDesc}`
      };
    },
    /* ===========================
             * BEM
             * ===========================
             */
    bem(e, m){
      let classStr = `mod-web-activity-detail__${e}`;

      if (m){
        classStr += `--${classStr}`;
      }
      return classStr;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/standard';
@import '@/assets/scss/mixins';

.mod-web-activity-detail {
  overflow: hidden;
  padding-bottom: sizeTrans(120);
  text-align: left;
  color: #000000;
  &__back-btn,
  &__back-btn-mb {
    position: relative;
    cursor: pointer;
    &:before {
      content: '';
      position: absolute;
      background-image: url("../../../../assets/images/activity/goback.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
  &__back-btn {
    font-size: sizeTrans(20);
    line-height: sizeTrans(32);
    &:before {
      width: sizeTrans(24);
      height: sizeTrans(24);
      top: sizeTrans(4);
      left: sizeTrans(-40);
    }
  }
  &__back-btn-mb {
    display: none;
    position: absolute;
    top: sizeTrans(70);
    left: sizeTrans(35);
    font-size: sizeTrans(16);
    line-height: sizeTrans(20);
    &:before {
      width: sizeTrans(18);
      height: sizeTrans(18);
      top: sizeTrans(0);
      left: sizeTrans(-20);
    }
  }
  &__main {
    display: flex;
    max-width: 1120px;
    margin: 0 auto;
    padding-top: sizeTrans(125);
    justify-content: center;
  }
  &__left-container {
    width: calcPcVw(623);
    max-width: 623px;
  }
  &__right-container {
    width: calcPcVw(376);
    max-width: 376px;
    margin-left: sizeTrans(120);
    margin-top: sizeTrans(215);
  }
  &__right-info {
    display: none;
  }
  &__banner {
    width: 100%;
    margin-top: sizeTrans(40);
  }
  &__head-banner {
    display: none;
  }
  &__banner-wrap.common-banner {
    display: block;
  }
  &__main-info {
    padding: 0;
  }

  &__title {
    margin-top: sizeTrans(80);
    margin-bottom: sizeTrans(10);
    font-size: sizeTrans(24);
    line-height: sizeTrans(36);
    word-break: break-word;
  }

  &__sessions-wrap {
    padding-bottom: sizeTrans(35);
  }

  &__sub-title {
    margin-bottom: sizeTrans($space_20);
    @include title_m();
  }

  &__sub-title-tips {
    @include title_m_tips();
  }

  &__main-detail {
    // @include pagePadding();
  }

  &__title-detail {
    padding: sizeTrans(40) 0 sizeTrans(20);
    font-size: sizeTrans(20);
    line-height: sizeTrans(32);
  }

  &__content-section.content-section,
  &__attention-section.content-section{
    overflow: hidden;
    // 图片样式顶格
    ::v-deep .image-list,
    ::v-deep .title,
    ::v-deep .paragraph,
    ::v-deep .heading,
    ::v-deep .code-block,
    ::v-deep .list,
    ::v-deep .blockquote,
    ::v-deep .image {
      margin-top: 0;
    }
    font-size: sizeTrans(14);
    line-height: sizeTrans(20);
  }
  &__skeleton {
    display: block;
    max-width: sizeTrans(1120);
    margin: sizeTrans(50) auto;
  }
  &__skeleton-mb {
    display: none;
    margin: sizeTrans(50) 0;
  }

  @include touch {
    &__main {
      display: block;
      padding-top: 0;
      position: relative;
    }
    &__back-btn {
      display: none;
    }
    &__back-btn-mb {
      display: block;
    }
    &__main-info {
      padding: sizeTrans(30) sizeTrans($space_20) 0;
    }
    &__title {
      margin-top: 0;
    }
    &__left-container {
      width: 100%;
      max-width: 100%;
    }
    &__right-container {
      display: none;
    }
    &__right-info {
      display: block;
    }
    &__head-banner {
      display: block;
    }
    &__banner-wrap {
      display: none;
    }
    &__content-section {
      margin-top: sizeTrans(20);
    }
    &__title-detail {
      padding: sizeTrans(20) 0;
      font-size: sizeTrans(20);
      line-height: sizeTrans(32);
    }
    &__skeleton {
      display: none;
    }
    &__skeleton-mb {
      display: block;
    }
  }
}
</style>
